import { ReactElement } from 'react';
import Skeleton from '@mui/material/Skeleton';
import { useId } from '../../../../lib/hooks/useId';
import { classes } from '../../../../lib/utils/cssUtils';
import styles from './SkeletonCourseList.module.scss';
import { courseListIds } from '../../../../lib/tests/testIds';
import { ViewType } from '../../../../lib/types/aemDataModels';

export type SkeletonCourseListProps = {
  viewType: ViewType;
};

const SkeletonCourse = () => {
  return (
    <div className={styles.course}>
      <div className={styles.imageWrapper}>
        <Skeleton variant="rectangular" className={styles.image} />
      </div>
      <div className={styles.content}>
        <Skeleton variant="rounded" className={styles.courseType} />
        <Skeleton variant="rounded" className={styles.courseTitle} />
        <Skeleton variant="rounded" className={styles.description} />
        <Skeleton variant="rounded" className={styles.descriptionEnd} />
        <Skeleton variant="rounded" className={styles.duration} />
        <Skeleton variant="rounded" className={styles.link} />
      </div>
    </div>
  );
};

const SkeletonCourseList = ({ viewType }: SkeletonCourseListProps): ReactElement => {
  const id = useId('skeleton-course-list-');

  return (
    <div className={classes(styles.courseList, styles[viewType])} data-testid={courseListIds.skeletonCourseList}>
      {Array.from(new Array(5), (_, i) => i).map(value => (
        <SkeletonCourse key={`${id}${value}`} />
      ))}
    </div>
  );
};

export default SkeletonCourseList;
